import Vue from "vue";
import Router from "vue-router";

import Layout from "@/components/Layout/Layout";
import LoginPage from "@/components/sections/LoginPage/LoginPage";
import AboutPage from "@/components/sections/AboutPage/AboutPage";
import AuthenticatePage from "@/components/sections/AboutPage/AuthenticatePage";

// import SubjectLayoutPage from "@/components/sections/SubjectPage/SubjectLayoutPage";
// import SubjectPage from "@/components/sections/SubjectPage/SubjectPage";
// import SubjectQuestionsPage from "@/components/sections/SubjectPage/SubjectQuestionsPage";
// import SubjectQuestionsLayoutPage from "@/components/sections/SubjectPage/SubjectQuestionsLayoutPage/SubjectQuestionsLayoutPage";
// import SubjectQuestionsAnswerPage from "@/components/sections/SubjectPage/SubjectQuestionsLayoutPage/SubjectQuestionsAnswerPage";

import TopicsLayout from "@/components/sections/TopicsPage/TopicsLayout";
import TopicsPage from "@/components/sections/TopicsPage/TopicsPage";
import QuestionsPage from "@/components/sections/TopicsPage/QuestionsPage/QuestionsPage";
import QuestionsLayout from "@/components/sections/TopicsPage/QuestionsPage/QuestionsLayout";
import AnswerPage from "@/components/sections/TopicsPage/AnswerPage/AnswerPage";

Vue.use(Router);

export default new Router({
  mode: "history",
  scrollBehavior: function(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  linkExactActiveClass: "is-active",
  //base: `2020`,

  routes: [
    {
      path: "/",
      name: "Layout",
      redirect: "/login",
      //component: Layout,
    },
    {
      path: "/authenticate/:code",
      name: "Authenticate",
      component: AuthenticatePage,
    },
    {
      path: "/login",
      name: "LoginPage",
      component: LoginPage,
    },
    {
      path: "/about",
      name: "AboutPage",
      component: AboutPage,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/topics/:userId",
      component: TopicsLayout,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "",
          name: "TopicsPage",
          component: TopicsPage,
        },
        {
          path: "questions/:topicId",
          component: QuestionsLayout,
          children: [
            {
              path: "",
              name: "QuestionsPage",
              component: QuestionsPage,
            },
            {
              path: "answer/:questionId",
              name: "AnswerPage",
              component: AnswerPage,
            },
          ],
        },
      ],
    },
  ],
});
